import React from 'react';
import logo from '../media/logo_small.svg';
import { motion, useViewportScroll, useTransform } from 'framer-motion';

function Logo() {

    const { scrollYProgress } = useViewportScroll();
    const anim = useTransform(scrollYProgress, [0, 0.02], [0, 1]);   

    return (
        
            <img src={logo} alt='logo' className='nav__logo'/>
        
    );
}

export default Logo;